module.exports = __webpack_public_path__ + "static/media/contact.bd481a12.png";